<template>
    <modal :show.sync="modals.is_show" :hide-footer="true" bodyClasses="preview-modal">
        <h3 class="mb-3">Mortgage Eligible</h3>
        <BankSelectionDetailsModal :show_bank_details.sync="modals.show_bank_details" :bank="view_bank" />
        <div class="card-table">
            <el-table
            v-loading="is_loading"
            ref="multipleTable"
            :data="tableData"
            style="width: 100%"
            >
                <el-table-column
                    prop="bank_name"
                    label="Bank Name"
                    width="130"
                    >
                    <template slot="header" slot-scope="scope">
                        <span class="text-break">{{ scope.column.label }}</span>
                    </template>
                    <template slot-scope="scope">
                        <el-image style="height: 40px;" :src="scope.row.bank_image_url" fit="contain">
                        <template #error>
                                <div class="image-slot">
                                    <span class="d-inline-block text-truncate" style="max-width: 90px;">{{ scope.row.bank_name }}</span>
                                </div>
                            </template>
                        </el-image>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="est_interest_rate"
                    width="200"
                    label-class-name="d-flex justify-content-center"
                    >
                    <template slot="header">
                        <span class="text-break text-center w-full">Est Int Rate</span>
                    </template>
                    <template slot-scope="scope">
                        <p class="top-line text-center">{{ scope.row.bank_loan_interest_rate }}% p.a</p>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="max_eligibility"
                    label="Max Eligibility Amount"
                    min-width="200"
                    >
                    <template slot="header" slot-scope="scope">
                        <span class="text-break">{{ scope.column.label }}</span>
                    </template>
                    <template slot-scope="scope">
                        <span class="top-line mr-2" :class="scope.row.bank_loan_eligibility_amount > 0 ? 'text-success':'text-danger'">RM {{ scope.row.bank_loan_eligibility_amount | moneyFormatter }}</span>
                        <span>({{ scope.row.bank_loan_tenure_year }} yrs)</span>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="monthly_repayment"
                    label="Monthly Repayment"
                    min-width="200"
                    >
                    <template slot="header" slot-scope="scope">
                        <span class="text-break">{{ scope.column.label }}</span>
                    </template>
                    <template slot-scope="scope">
                        <p class="top-line">RM {{ scope.row.bank_installable_amount | moneyFormatter }}</p>
                    </template>
                </el-table-column>
                <el-table-column
                    label="Bank Details"
                    width="120"
                    >
                    <template slot="header" slot-scope="scope">
                        <span class="text-break">{{ scope.column.label }}</span>
                    </template>
                    <template slot-scope="scope">
                        <el-button type="text" @click="showBankDetails(scope.row)">View</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </modal>  
</template>
<script>
import { axios, services, getHeader, notifyFunctionMixin } from '@/assets/js/httpImports.js'
import { Table, TableColumn, Button, Image } from 'element-ui'
import BankSelectionDetailsModal from '@/views/CustomerProfile/CustomerModals/SolutionScenarioModals/BankSelectionDetailsModal'

    export default {
        components:{
            BankSelectionDetailsModal,
            [Table.name]: Table,
            [TableColumn.name]: TableColumn,
            [Button.name]: Button,
            [Image.name]: Image,
        },
        mixins: [notifyFunctionMixin],
        data() {
            return {
                modals: {
                    show_bank_details: false,
                    compare_banks: false,
                    is_show: false
                },
                is_loading: false,
                tableData: [],
                view_bank: null,
            }
        },
        methods: {
            showBankDetails(bank) {
                this.modals.show_bank_details = true
                this.view_bank = bank
            },
            async check(customer_id){
                this.modals.is_show = true
                this.is_loading = true
                    try{
                    const res = await axios.get(services.customer + 'customer/' + customer_id +'/dsr.eligibilities', {headers: getHeader()})
                    this.tableData = res.data.data.bank_eligibilities
                    this.tableData.sort((a, b) => parseFloat(a.bank_loan_eligibility_amount) > parseFloat(b.bank_loan_eligibility_amount) ? -1 : 1);
                    this.is_loading = false
                }catch(e){
                    this.tableData = []
                }
            },
        }
    }
</script>